import { Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import styled from 'styled-components'
import { REAL_DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'
import { useGeneralContext } from './contexts/GeneralContext'
import MarkTableInstantResult from './partials/MarkTableInstantResult'
import Percentage from './partials/Percentage'
import ZoomingAnimation from './partials/ZoomingAnimation'
import { navDirections } from './utils/navDirections'

function ExamInstantResult() {
    const [answers, setAnswers] = useState([])
    const { examSelected, setExamSelected } = useGeneralContext()
    const { userDetails } = useAuthContext()

    function getFromDB() {
        const dbRef = REAL_DB.ref()

        dbRef
            .child('exams')
            .child(examSelected?.id)
            .child(userDetails?.uid)
            .on('value', (snapshot) => {
                const data = snapshot.val()
                !!data ? setAnswers(data?.answers) : setAnswers('')
            })
    }

    function calculateMarkPercent() {
        const totalMark = answers.length * 4
        let mark = 0
        let correctAnswers = 0
        let wrongAnswers = 0

        answers.forEach((el) => {
            if (el?.myAnswer === el?.correctAnswer) {
                mark += 4
                correctAnswers += 1
            } else if (el?.myAnswer === '') {
                mark += 0
            } else {
                mark -= 1
                wrongAnswers += 1
            }
        })

        const percentage =
            Math.round((mark / totalMark) * 100) < 0
                ? 0
                : Math.round((mark / totalMark) * 100)

        return {
            mark: mark,
            totalMark: totalMark,
            percentage: percentage,
            questionAttended: correctAnswers + wrongAnswers,
            correctAnswers: correctAnswers,
            wrongAnswers: wrongAnswers
        }
    }

    useEffect(() => {
        !!examSelected && getFromDB()

        return () => setExamSelected('')
    }, [examSelected])

    if (!!!examSelected || !!!userDetails)
        return <Redirect to={navDirections.HOME} />

    return (
        <InstantResultContainer>
            <Heading>{examSelected?.title}</Heading>
            {!!answers.length && (
                <ResultSection>
                    <PercentageSection>
                        <Grid
                            container
                            spacing={3}
                            alignItems="center"
                            justify="center"
                        >
                            <Grid item xs={5}>
                                <Percentage
                                    percent={calculateMarkPercent().percentage}
                                />
                            </Grid>
                            <Grid item xs={7}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <SubjectName>
                                            {examSelected?.subject}
                                        </SubjectName>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <YourMark>
                                            {`Your Mark`}
                                            <span>{`:`}</span>
                                            {calculateMarkPercent().mark}
                                        </YourMark>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TotalMark>
                                            {`Total Mark`}
                                            <span>{`:`}</span>
                                            {calculateMarkPercent().totalMark}
                                        </TotalMark>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <DetailSection>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <TotalQuestions>
                                        {`Total Questions`}
                                        <span>{`:`}</span>
                                        {answers?.length}
                                    </TotalQuestions>
                                </Grid>
                                <Grid item xs={12}>
                                    <AttendedQuestions>
                                        {`Questions Attended`}
                                        <span>{`:`}</span>
                                        {
                                            calculateMarkPercent()
                                                .questionAttended
                                        }
                                    </AttendedQuestions>
                                </Grid>
                            </Grid>

                            <MarkTableInstantResult
                                correctNo={
                                    calculateMarkPercent().correctAnswers
                                }
                                wrongNo={calculateMarkPercent().wrongAnswers}
                            />
                        </DetailSection>
                    </PercentageSection>
                    <GotoButton>
                        <Link to={navDirections.EXAMS}>View Exams</Link>
                    </GotoButton>
                </ResultSection>
            )}

            {!!!answers.length && <ZoomingAnimation />}
        </InstantResultContainer>
    )
}

const InstantResultContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const ResultSection = styled.div`
    margin-top: 40px;
    padding: 30px 20px;
    max-width: 450px;
    background: #2e2e53;
    box-shadow: -5px 3px 14px rgba(0, 0, 0, 0.12),
        2px 8px 10px rgba(0, 0, 0, 0.14), 2px 5px 5px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    color: #fff;
    font-weight: 600;
`

const SubjectName = styled.p`
    font-size: 18px;
`
const YourMark = styled.p`
    span {
        margin-left: 2ch;
        margin-right: 1ch;
    }
`
const TotalMark = styled.p`
    span {
        margin-left: 1.5ch;
        margin-right: 1ch;
    }
`
const TotalQuestions = styled.p`
    span {
        margin-left: 5.3ch;
        margin-right: 1ch;
    }
`
const AttendedQuestions = styled.p`
    span {
        margin-left: 2ch;
        margin-right: 1ch;
    }
`

const PercentageSection = styled.div`
    width: 100%;
    color: #fff;
    p {
        font-weight: 600;
    }
`
const DetailSection = styled.div`
    margin-top: 30px;
`

const GotoButton = styled.div`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    > a {
        padding: 15px 20px;
        text-decoration: none;
        border-radius: 6px;
        width: 100%;
        color: #fff;
        background: #363862;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
    }
`

export default ExamInstantResult
